export const aggregate3Signature = '0x82ad56cb'
